import React from 'react';
import T from "prop-types";
import { Title } from '../../atoms';

export const AddressRow = ({ address1,
  address2,
  city,
  postalCode,
  country,
  title,
  titleCls,
  boxCls,
  textCls,
  text,
  ifText,
  ifCustomerName,
  customerName }) => {
  const address = [
    { text: address2 }, { text: address1 }, { text: postalCode }, { text: city }, { text: country }
  ];
  return <div className='address-container'>
    <Title text={title} className={titleCls} />
    <div className={boxCls}>
      {ifCustomerName && <Title text={customerName} className={textCls} />}
      {address.map((e, i) => (
        <Title text={e.text} className={textCls} key={i} />
      ))}
      {ifText && <Title text={text} className={textCls} />}
    </div>
  </div>;
};

AddressRow.T = {
  title: T.string,
  titleCls: T.string,
  boxCls: T.string,
  textCls: T.string,
  ifText: T.bool,
  ifCustomerName: T.bool,
};

AddressRow.defaultProps = {
  title: "Customer address",
  titleCls: "topText text",
  boxCls: "address-box text",
  textCls: "text",
  ifText: false,
  ifCustomerName: false,
};

